import {
  JobPostingStatus,
  JobPostingStatusMapper,
  PayType,
  ScheduleType,
} from '~/domain/PermanentJobs/enums';
import { ProfessionTypeEnum } from '~/models/Profession';
import {
  ICreateDraftJobPostApiResponse,
  ICreateDraftJobResult,
  IDraftJobPostEntity,
  IGetDraftJobPostApiResponse,
  IGetDraftJobPostResult,
} from '../types';

const toCreateDraftJobPostResult = (
  response: ICreateDraftJobPostApiResponse,
): ICreateDraftJobResult => {
  return {
    id: response.data.postingId,
  } satisfies ICreateDraftJobResult;
};

const toGetDraftJobPostResult = (response: IGetDraftJobPostApiResponse): IGetDraftJobPostResult => {
  return {
    data: {
      benefits: response.data.benefits,
      benefitsOther: response.data.benefitsOther,
      closedAt: response.data.closedAt,
      closedBy: response.data.closedBy,
      createdAt: response.data.createdAt,
      createdBy: response.data.createdBy,
      description: response.data.description,
      expectedDays: response.data.expectedDays,
      id: response.data.id,
      maxRate: response.data.salaryRange?.max,
      minRate: response.data.salaryRange?.min,
      officeId: response.data.officeId,
      officeName: response.data.officeName,
      officeSelected: response.data.officeSelected,
      officeSpecialty: response.data.specialty,
      payType: response.data.salaryRange?.payType as PayType,
      professionType: response.data.professionType as ProfessionTypeEnum,
      publishedAt: response.data.publishedAt,
      scheduleType: response.data.scheduleType as ScheduleType,
      status: JobPostingStatusMapper.safeCast(response.data.status) as JobPostingStatus,
      subProfession: response.data.subProfession,
      title: response.data.title,
      updatedAt: response.data.updatedAt,
      updatedBy: response.data.updatedBy,
      yearlyRate: response.data.salaryRange?.yearly,
    } satisfies IDraftJobPostEntity,
  } satisfies IGetDraftJobPostResult;
};

export const DraftJobPostAdapters = {
  toCreateDraftJobPostResult,
  toGetDraftJobPostResult,
};
